import { apiSlice } from "./apiSlice";
import { GET_VENDOR_DETAILS_URL, GET_VENDOR_PRODUCTS_URL } from "../constants";

export const vendorStoreSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchVendorDetails: builder.query({
      query: (storeName) => ({
        url: `${GET_VENDOR_DETAILS_URL}?storeName=${storeName}`,
        method: "GET",
      }),
    }),
    fetchVendorProducts: builder.query({
      query: ({
        storeName,
        page = 1,
        limit = 16,
        sort = "latest",
        filters,
      }) => ({
        url: `${GET_VENDOR_PRODUCTS_URL}?storeName=${storeName}&page=${page}&limit=${limit}&sort=${sort}&filters=${JSON.stringify(
          filters,
        )}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useFetchVendorDetailsQuery, useFetchVendorProductsQuery } =
  vendorStoreSlice;
